module.exports = __webpack_public_path__ + "lxzs.png?98cecbd4c6d9fc5941053c56d62ddc7f";


//////////////////
// WEBPACK FOOTER
// ./static/assets/lxzs.png
// module id = 537
// module chunks = 0